let user =sessionStorage.getItem("user");
let hideprice = user&&user.festival?user.festival.id == 224:true
export default {
  hideprice
}
